// admin-client/src/components/usePanScroll.js
// =============================================================================
// Right-click-drag panning for any scrollable element. Returns:
//
//   {
//     ref,               // attach to the scrolling container
//     onMouseDown,       // attach to onMouseDown
//     onContextMenu,     // attach to onContextMenu (suppresses the browser menu)
//   }
//
// Usage:
//   const pan = usePanScroll();
//   <div ref={pan.ref} onMouseDown={pan.onMouseDown} onContextMenu={pan.onContextMenu}
//        className="overflow-auto …">
//     …
//   </div>
//
// Left-click is left alone — cells / buttons still receive their normal
// onClick. Only the right mouse button triggers a pan.
// =============================================================================

import { useRef } from 'react';

export function usePanScroll() {
  const ref = useRef(null);
  const dragRef = useRef(null);

  function moveListener(e) {
    const el = ref.current;
    const d = dragRef.current;
    if (!el || !d) return;
    el.scrollLeft = d.scrollLeft - (e.clientX - d.startX);
    el.scrollTop  = d.scrollTop  - (e.clientY - d.startY);
  }
  function upListener() {
    const el = ref.current;
    if (el) {
      el.style.cursor = '';
      el.style.userSelect = '';
    }
    dragRef.current = null;
    document.removeEventListener('mousemove', moveListener);
    document.removeEventListener('mouseup', upListener);
  }

  function onMouseDown(e) {
    if (e.button !== 2) return; // right button only
    const el = ref.current;
    if (!el) return;
    e.preventDefault();
    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      scrollLeft: el.scrollLeft,
      scrollTop:  el.scrollTop,
    };
    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
    document.addEventListener('mousemove', moveListener);
    document.addEventListener('mouseup',   upListener);
  }
  function onContextMenu(e) {
    // Suppress the OS menu so right-drag is unobstructed inside this element.
    e.preventDefault();
  }

  return { ref, onMouseDown, onContextMenu };
}

export default usePanScroll;
